import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-reset-password-success-dialog',
  templateUrl: './reset-password-success-dialog.component.html',
  styleUrls: ['./reset-password-success-dialog.component.scss']
})
export class ResetPasswordSuccessDialogComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<ResetPasswordSuccessDialogComponent>) { }

  ngOnInit() {
  }
  closeSuccessResetPWDDialog(){
    this.dialogRef.close();
  }

}
